import { createSelector } from 'reselect';
import { getRestaurantDetails } from '../../selectors/menuSelectors';

export const getPayments = (state: WebOrder.State) =>
  state.payments.items || {};

export const getPayment = (
  state: WebOrder.State,
  { paymentId }: { paymentId: string }
) => getPayments(state)[paymentId];

const getRestaurantDetailsTemporaryWrapper = (state: WebOrder.State) => {
  const deliveryType = state.location.params.type;
  const vrId = state.location.params.vrid;
  const prId =
    deliveryType === 'collection' ? state.location.params.id : undefined;
  const deliveryLocationId =
    deliveryType === 'delivery' ? state.location.params.id : undefined;

  if (!deliveryType && !vrId && (!prId || !deliveryLocationId)) {
    return undefined;
  }

  return getRestaurantDetails(state, {
    deliveryType,
    vrId,
    prId,
    deliveryLocationId
  });
};
export const getAvailablePayments = createSelector<
  WebOrder.State,
  WebOrder.State.Payments['items'],
  ReturnType<typeof getRestaurantDetailsTemporaryWrapper>,
  WebOrder.State.Payment[]
>(
  [state => state.payments.items, getRestaurantDetailsTemporaryWrapper],
  (items, restaurant) => {
    if (!restaurant) {
      return [];
    }

    const { AcceptCardOrders, AcceptCashOrders } = restaurant;

    return Object.values(items)
      .filter(p => p.status !== 'error' && p.status !== 'none')
      .filter(p =>
        AcceptCashOrders ? true : p.PaymentAccountType !== 'CashPaymentAccount'
      )
      .filter(p =>
        AcceptCardOrders ? true : p.PaymentAccountType !== 'CardPaymentAccount'
      )
      .sort((a, b) => a.displayOrder - b.displayOrder);
  }
);

export const getRemovablePayments = createSelector<
  WebOrder.State,
  WebOrder.State.Payments['items'],
  WebOrder.State.Payment[]
>([state => state.payments.items], items => {
  return Object.values(items)
    .filter(p => p.CanRemoveFromCustomerView)
    .sort((a, b) => a.displayOrder - b.displayOrder);
});

export const getSelectedPaymentId = (state: WebOrder.State) =>
  state.basket.paymentId;
export const getSelectedPayment = (state: WebOrder.State) => {
  if (getSelectedPaymentId(state) !== undefined) {
    return state.payments.items[getSelectedPaymentId(state)];
  }
  return undefined;
};
